export default {
  // 正式环境
  apihost: 'https://w.bangbangce.com/rest.php', // 接口api--正式环境接口路径
  skipUrl: 'https://w.bangbangce.com', // 跳转链接--正试环境跳转
  urlimg: 'http://vue.bangbangce.com', // vue分享地址--正式服分享链接
  serviceUrl: 'https://service.bangbangce.com/wenxin',
  // 测试环境
  // apihost: 'https://exam.bangbangce.com/rest.php', // 接口api--测试环境路径
  // skipUrl: 'https://exam.bangbangce.com', // 跳转链接--测试环境跳转
  // urlimg: 'http://vuetest.bangbangce.com', // vue分享地址--测试服分享链接
  // serviceUrl: 'https://service.test.bangbangce.com',
  // 七牛图片
  urlimg1: 'https://resource.bangbangce.com', // 七牛图片路径
  // 分享帮帮首页链接
  urllink: 'http://w.bangbangce.com'
}



// WEBPACK FOOTER //
// ./src/common/apihost.js